
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth0 } from './useAuth0';
import { intakePortalApi } from '@/utils/api';
import type { IntakePortalSessionForUser } from '@/models/types';

interface UseSessionManagementReturn {
  sessions: IntakePortalSessionForUser[];
  isLoading: boolean;
}

export const useSessionManagement = (): UseSessionManagementReturn => {
  const { user } = useAuth0();

  const { data: sessionsData, isLoading } = useQuery<IntakePortalSessionForUser[]>({
    queryKey: ['user-sessions'],
    queryFn: async () => {
      const response = await intakePortalApi.getUserSessions();
      return response;
    },
    enabled: !!user,
  });

  const sessions = useMemo(() => sessionsData || [], [sessionsData]);

  return {
    sessions,
    isLoading,
  };
};